import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3551c8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-style-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "视频预览封面", -1))
const _hoisted_3 = { class: "background-image-wrapper" }
const _hoisted_4 = { class: "background-image" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row switch-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "自动播放：", -1))
const _hoisted_8 = {
  class: "switch-wrapper",
  style: {"width":"60%"}
}

import type { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTVideoElement } from '@/types/slides'
import { getImageDataURL } from '@/utils/image'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import FileInput from '@/components/FileInput.vue'
import Button from '@/components/Button.vue'
import Switch from '@/components/Switch.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoStylePanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleVideoElement = handleElement as Ref<PPTVideoElement>

const { addHistorySnapshot } = useHistorySnapshot()

const updateVideo = (props: Partial<PPTVideoElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

// 设置视频预览封面
const setVideoPoster = (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  getImageDataURL(imageFile).then(dataURL => updateVideo({ poster: dataURL }))
}

return (_ctx: any,_cache: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FileInput, {
        onChange: _cache[0] || (_cache[0] = files => setVideoPoster(files))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "content",
              style: _normalizeStyle({ backgroundImage: _unref(handleVideoElement).poster ? `url(${_unref(handleVideoElement).poster})` : '' })
            }, [
              _createVNode(_component_IconPlus)
            ], 4)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Button, {
        style: {"flex":"1"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (updateVideo({ poster: '' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode("重置封面")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Switch, {
          value: _unref(handleVideoElement).autoplay,
          "onUpdate:value": _cache[2] || (_cache[2] = value => updateVideo({ autoplay: value }))
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})